import React, { useEffect, useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../../components/ui/dialog";
import { toast } from "sonner";
import { Search, KeyRound } from "lucide-react";

export default function AdminStudents() {
  const [students, setStudents] = useState([]);
  const [q, setQ] = useState("");
  const [sel, setSel] = useState(null);
  const [access, setAccess] = useState([]);
  const [products, setProducts] = useState([]);
  const [grantPid, setGrantPid] = useState("");

  const load = (query = "") => api.get(`/admin/students${query ? `?q=${query}` : ""}`).then((r) => setStudents(r.data)).catch(() => {});
  useEffect(() => { load(); api.get("/admin/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  const openStudent = async (s) => {
    setSel(s);
    const { data } = await api.get(`/admin/students/${s.id}/access`);
    setAccess(data);
  };
  const doAccess = async (action, product_id) => {
    try { await api.post(`/admin/students/${sel.id}/access`, { action, product_id }); toast.success("Updated"); const { data } = await api.get(`/admin/students/${sel.id}/access`); setAccess(data); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div>
      <h1 className="font-heading text-2xl font-bold mb-6">Students</h1>
      <div className="relative max-w-xs mb-4">
        <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-content-muted" />
        <Input value={q} onChange={(e) => { setQ(e.target.value); load(e.target.value); }} placeholder="Search students…" className="pl-9 bg-card border-line" data-testid="admin-students-search" />
      </div>
      <div className="card-surface overflow-x-auto">
        <table className="w-full text-sm">
          <thead><tr className="border-b border-line text-left text-content-muted">
            <th className="px-4 py-3 font-medium">Name</th><th className="px-4 py-3 font-medium">Email</th>
            <th className="px-4 py-3 font-medium">Mobile</th><th className="px-4 py-3 font-medium">Purchases</th>
            <th className="px-4 py-3 font-medium">Tests</th><th className="px-4 py-3" />
          </tr></thead>
          <tbody>
            {students.map((s) => (
              <tr key={s.id} className="border-b border-line/50 hover:bg-card-hover/50" data-testid={`admin-student-row-${s.id}`}>
                <td className="px-4 py-3 font-medium">{s.name}</td>
                <td className="px-4 py-3 text-content-secondary">{s.email}</td>
                <td className="px-4 py-3 text-content-secondary">{s.mobile || "—"}</td>
                <td className="px-4 py-3">{s.orders}</td>
                <td className="px-4 py-3">{s.attempts}</td>
                <td className="px-4 py-3 text-right"><Button size="sm" variant="outline" className="border-line rounded-full" onClick={() => openStudent(s)} data-testid={`admin-student-access-${s.id}`}><KeyRound className="w-3.5 h-3.5 mr-1" /> Access</Button></td>
              </tr>
            ))}
            {students.length === 0 && <tr><td colSpan={6} className="px-4 py-10 text-center text-content-muted">No students.</td></tr>}
          </tbody>
        </table>
      </div>

      {sel && (
        <Dialog open onOpenChange={() => setSel(null)}>
          <DialogContent className="bg-card border-line max-w-lg">
            <DialogHeader><DialogTitle>{sel.name} — Access</DialogTitle></DialogHeader>
            <div className="space-y-2 max-h-60 overflow-y-auto">
              {access.length === 0 && <p className="text-sm text-content-muted">No product access.</p>}
              {access.map((a) => (
                <div key={a.product_id} className="flex items-center justify-between text-sm border-b border-line pb-2">
                  <span>{a.product_name} <span className={`text-xs ${a.active ? "text-emerald-400" : "text-red-400"}`}>({a.active ? "active" : "revoked"})</span></span>
                  {a.active ? <button className="text-xs text-red-400" onClick={() => doAccess("revoke", a.product_id)}>Revoke</button>
                    : <button className="text-xs text-emerald-400" onClick={() => doAccess("grant", a.product_id)}>Grant</button>}
                </div>
              ))}
            </div>
            <div className="flex gap-2 pt-2">
              <select value={grantPid} onChange={(e) => setGrantPid(e.target.value)} className="flex-1 h-10 rounded-md bg-ink border border-line px-3 text-sm">
                <option value="">Grant a product…</option>
                {products.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
              </select>
              <Button className="btn-ember" disabled={!grantPid} onClick={() => { doAccess("grant", grantPid); setGrantPid(""); }} data-testid="grant-access-btn">Grant</Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
